<script lang="ts">
	import { browser } from '$app/environment';
	import { onNavigate } from '$app/navigation';
	import { onMount } from 'svelte';

	interface Props {
		key: string | undefined;
	}

	let { key }: Props = $props();

	function trackPageView(path: string, location: string, title: string) {
		if (!browser || !window.dataLayer) return;

		window.dataLayer.push({
			event: 'page_view',
			page_path: path,
			page_location: location,
			page_title: title
		});
	}

	onMount(() => {
		if (!browser || !key) {
			console.warn('GTM: No key provided or not in browser environment');
			return;
		}

		try {
			// Initialize dataLayer
			window.dataLayer = window.dataLayer || [];

			// Check if GTM script is already present
			if (document.getElementById('google-tag-manager')) {
				// GTM already initialized, just track the current page
				trackPageView(window.location.pathname, window.location.href, document.title);
				return;
			}

			// Add GTM script
			const script = document.createElement('script');
			script.id = 'google-tag-manager';
			script.innerHTML = `
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','${key}');
			`;
			document.head.appendChild(script);

			// Add noscript iframe for browsers with JavaScript disabled
			const noscript = document.createElement('noscript');
			const iframe = document.createElement('iframe');
			iframe.src = `https://www.googletagmanager.com/ns.html?id=${key}`;
			iframe.height = '0';
			iframe.width = '0';
			iframe.style.display = 'none';
			iframe.style.visibility = 'hidden';
			noscript.appendChild(iframe);
			document.body.prepend(noscript);

			// Track initial page view
			trackPageView(window.location.pathname, window.location.href, document.title);
		} catch (error) {
			console.error('Failed to initialize Google Tag Manager:', error);
		}
	});

	// Track page changes and send page_view event
	onNavigate((navigation) => {
		if (!browser) return;

		// Use the navigation.to information for more accurate tracking
		navigation.complete.then(() => {
			const path = navigation.to?.url.pathname || window.location.pathname;
			const location = navigation.to?.url.href || window.location.href;
			trackPageView(path, location, document.title);
		});
	});
</script>
